import { StatusType } from '../../../types/videos'
import { PosterState } from '../../types/poster'

export const getPosterState = (carouselItem: {
  link?: string
  status?: StatusType
  posterUrl?: string
}): PosterState => {
  if (!carouselItem.link) return 'empty'
  if (carouselItem.status === 'READY') return 'ready'
  return 'processing'
}
